import { z } from "zod";
import { useEffect, useRef, useState } from "react";
import { valueExtraction } from "../../models/extraction";
import { attributesValidator } from "../../models/schemasV2";

export const ExtractionValueGroup = ({
  valueGroup,
  attributes,
  setSourceElementId,
}: {
  valueGroup: z.infer<typeof valueExtraction>[];
  attributes: Record<string, z.infer<typeof attributesValidator>>;
  setSourceElementId?: (sourceElementId: string) => void;
}) => {
  const [columns, setColumns] = useState(1);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      setColumns(width >= 600 ? 2 : 1); // Adjust 500px threshold as needed
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={`grid gap-2 w-full text-sm ${
        columns === 1 ? "grid-cols-1" : "grid-cols-2"
      }`}
      key={valueGroup.map((value) => value.attributeId).join("-")}
    >
      {valueGroup.map((value) => (
        <div key={value.attributeId} className="grid grid-cols-[200px_auto] ">
          <span className="text-gray-700 truncate">
            {attributes[value.attributeId].name}
          </span>
          <span
            className="font-medium text-gray-900 cursor-pointer"
            onClick={() => {
              if (
                value.metadata["_source_element_id"] &&
                typeof value.metadata["_source_element_id"] === "string"
              ) {
                setSourceElementId?.(value.metadata["_source_element_id"]);
              }
            }}
          >
            {value.value}
          </span>
        </div>
      ))}
    </div>
  );
};
